module.exports = __webpack_public_path__ + "static/media/london_25-sits_oppet_avslut_tyg_mito_miljo_2023_2_fyrkant.608da74d.jpg";